export default "__VITE_ASSET__240ca3bf__"